export default __webpack_public_path__ + "static/properties-dark-mode-29c017f1bff593dda9b640421ccba5a8.png";